import React from 'react'

/**
 * Componente de spinner de carga con diferentes tamaños
 * Usado para lazy loading y operaciones asíncronas
 */
const LoadingSpinner = ({ size = 'medium', color = '#3BC6C6', className = '' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
    xl: 'w-16 h-16'
  }

  const spinnerSize = sizeClasses[size] || sizeClasses.medium

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${spinnerSize} animate-spin rounded-full border-2 border-gray-200 border-t-transparent`}
        style={{
          borderTopColor: color,
          borderRightColor: color
        }}
      />
    </div>
  )
}

/**
 * Componente de carga con texto
 */
export const LoadingWithText = ({
  text = 'Cargando',
  size = 'medium',
  color = '#3BC6C6',
  className = ''
}) => (
  <div className={`flex flex-col items-center justify-center space-y-2 ${className}`}>
    <LoadingSpinner size={size} color={color} />
    <p
      className="text-sm font-bold animate-pulse"
      style={{ color: color }}
    >
      {text}
    </p>
  </div>
)

/**
 * Componente de skeleton para carga de contenido
 */
export const SkeletonLoader = ({
  lines = 3,
  className = ''
}) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: lines }).map((_, index) => (
      <div
        key={`dot-${index}`}
        className="h-4 bg-gray-200 rounded animate-pulse"
        style={{
          width: index === lines - 1 ? '60%' : '100%'
        }}
      />
    ))}
  </div>
)

/**
 * Componente de skeleton para cards
 */
export const CardSkeleton = ({ className = '' }) => (
  <div className={`bg-white rounded-lg border border-gray-200 p-6 ${className}`}>
    <div className="animate-pulse">
      <div className="h-6 bg-gray-200 rounded w-3/4 mb-4" />
      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded" />
        <div className="h-4 bg-gray-200 rounded w-5/6" />
      </div>
    </div>
  </div>
)

/**
 * Componente de skeleton para grid de elementos
 */
export const GridSkeleton = ({
  items = 6,
  className = ''
}) => (
  <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}>
    {Array.from({ length: items }).map((_, index) => (
      <CardSkeleton key={`skeleton-${index}`} />
    ))}
  </div>
)

/**
 * Componente de loading para imágenes
 */
export const ImagePlaceholder = ({
  width = '100%',
  height = 200,
  className = ''
}) => (
  <div
    className={`bg-gray-100 flex items-center justify-center ${className}`}
    style={{ width, height }}
  >
    <LoadingSpinner size="medium" />
  </div>
)

export default LoadingSpinner